import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";
import ScrollTrigger from "gsap/ScrollTrigger";
import gsap from "gsap";
import { TbCircleX } from 'react-icons/tb'

gsap.registerPlugin(ScrollTrigger)
ReactModal.setAppElement('#___gatsby')
export default function PopUpModal() {
  const [modalOpen, setModalOpen] = useState(false)
    useEffect(() => {
      if(!typeof window !== 'undefined' && !window.sessionStorage.getItem('modalViewed')){
        setTimeout(() => {
          setModalOpen(true)
        }, 500)
      }
    }, [])
    
    function handleModalClose() {
      setModalOpen(false)
      sessionStorage.setItem('modalViewed', true)
    }
  
  return (
    <>
    <ReactModal
    isOpen={modalOpen}
    role={"dialog"}
    portalClassName="popUpModal"
    onRequestClose={handleModalClose}
    preventScroll={true}
    shouldFocusAfterRender={true}
    aria={{
      labelledby: 'modalTitle',
      describedby: 'modalText'
    }}
    style = {
     { overlay: {
        backfaceVisibility: 'hidden',
        position:'fixed',
        zIndex:'800',
        overflow:"hidden !important",
        background:`rgb(0, 0, 0, 0.64)`
      },
      content: {
        borderRadius:'20px',
        inset: '40px',
        maxWidth:'500px',
        border:'solid 4px var(--black)',
        overflow:'auto',
        margin:'auto',
        height:'fit-content',
        maxHeight:'90vh',
        padding:'45px 25px'
      }
    }
    }
    contentLabel={`Init Pop-up Modal`}>
      <button className="modalClose" aria-label="close" title="Close" onClick={handleModalClose}><TbCircleX /></button>
      <h2>Saturday Urgent Care at VPC</h2>
      <p>Open 9am to 1pm</p>
      <p>Book Up to 48 hours in advance</p>
      <p>Online Appointments Only</p>
      <p>Click the link <a href="https://vaughanpeds.ca/blog/saturday-urgent-care-clinic/" className="hoverable">here</a> for more information</p>
      <a href="https://ocean.cognisantmd.com/online-booking/53cbf5df-f9d3-4724-84da-8d4031b2137a" target="_blank" rel="noopener noreferrer" className="cta">Book Now</a>
    </ReactModal>
    </>
  )
}